import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from '../../axiosConfig';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header';
import '../../styles/AuthPages.css';
  import { useTranslation } from 'react-i18next';


const UserLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth(); // 从 AuthContext 获取 login 函数

  
    const { t } = useTranslation();

  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    
    // 配置 x-www-form-urlencoded 格式的请求
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);

    axios.post('/yonghu/login', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 指定格式
      },
    })
      .then(response => {
        console.log("登录响应:", response);
        if (response.data.code === 0) {
          const { userId, token, username: zhanghao } = response.data;
          // 创建更完整的用户信息对象
          const userData = { 
            id: userId, 
            username, 
            zhanghao: zhanghao || username, // 确保有zhanghao属性
            role: 'yonghu' 
          };

          // 保存用户信息和令牌 - 同时存储到两个键名
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(userData));
          localStorage.setItem('userData', JSON.stringify(userData));
          
          // 也调用login函数，确保AuthContext状态更新
          if (typeof login === 'function') {
            login(userData, token);
          }
          
          // 获取用户完整信息（携带Token的统一实例）
          axios.get(`/yonghu/info/${userId}`)
            .then(userResponse => {
              if (userResponse.data.code === 0) {
                // 更新用户信息，包含更多详细数据
                const fullUserData = {
                  ...userData,
                  ...userResponse.data.data
                };
                
                // 同时更新两个存储
                localStorage.setItem('user', JSON.stringify(fullUserData));
                localStorage.setItem('userData', JSON.stringify(fullUserData));
                
                // 更新AuthContext
                if (typeof login === 'function') {
                  login(fullUserData, token);
                }
              }
              // 无论是否获取到完整信息，都跳转到用户详情页
              navigate(`/users/${userId}`);
            })
            .catch(err => {
              console.error("获取用户详情失败:", err);
              navigate(`/users/${userId}`); // 仍然跳转
            });
        } else {
          setError(response.data.msg || '登录失败，请检查用户名和密码');
        }
      })
      .catch(err => {
        console.error("登录请求失败:", err);
        setError('登录失败，请稍后再试');
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div className="home-page">
      <Header />
      <div className="auth-container">
        <div className="auth-header">
          <h1>{t('login.title')}</h1>
          <p>{t('login.subtitle')}</p>
        </div>
        
        {error && (
          <div className="auth-error">
            <FontAwesomeIcon icon={faExclamationCircle} /> {error}
          </div>
        )}
        
        <form className="auth-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">
              <FontAwesomeIcon icon={faUser} /> {t('login.username')}
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={t('login.usernamePlaceholder')}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">
              <FontAwesomeIcon icon={faLock} /> {t('login.password')}
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('login.passwordPlaceholder')}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="auth-btn" 
            disabled={submitting}
          >
            {submitting ? t('login.loggingIn') : t('login.loginButton')}
          </button>
        </form>
        
        <div className="auth-links">
          <Link to="/mobileregister">{t('login.mobileLogin')}</Link>
          <Link to="/register">{t('login.register')}</Link>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
